export enum CategoryStatusEnum {
  All = 0,
  Active = 1,
  Inactive = 2,
}

export const CategoryStatusStringEnum = {
  All : 'All',
  Active: 'Active',
  Inactive: 'Inactive'
};

export enum CategoryManagementStaticDataEnum{
Saving = 1,
Checquing = 2,
SoftudeLoan = 3
}

export const CategoryManagementStaticDataStringEnum = {
Saving: 'Saving',
Chequing: 'Chequing',
SoftudeLoan: 'Softude Loan',
};
